import { useSession } from 'next-auth/react';

import { canAccessProxyClient } from '~/features/proxy/model/business-rules/can-access-proxy-client';

export function useCanProxy() {
  const { data: session } = useSession();
  return canAccessProxyClient(session?.user?.isAdmin);
}
